import {
  excludeArchivedEntities,
  isArchivedEntity,
  type ArchiveLifecycleSource,
  type LifecycleStateFilterDto,
} from '@terra/shared-dto-types';

export const excludeArchivedSignals = <T extends ArchiveLifecycleSource>(
  signals: readonly T[],
): T[] => excludeArchivedEntities(signals, isArchivedEntity);

export const resolveSelectableSignalTotal = ({
  displayedTotalCount,
  lifecycleState,
  mutableTotalCount,
}: {
  displayedTotalCount: number;
  lifecycleState?: LifecycleStateFilterDto;
  mutableTotalCount?: number;
}): number =>
  lifecycleState === 'all' ? (mutableTotalCount ?? 0) : displayedTotalCount;

export const countSelectedMutableSignals = ({
  isAllFilteredSelected,
  selectableTotalCount,
  excludedCount,
  selectedCount,
}: {
  isAllFilteredSelected: boolean;
  selectableTotalCount: number;
  excludedCount: number;
  selectedCount: number;
}): number =>
  isAllFilteredSelected
    ? Math.max(selectableTotalCount - excludedCount, 0)
    : selectedCount;

export const selectMutableSignals = <
  T extends ArchiveLifecycleSource & { id: string },
>({
  signals,
  excludedIds,
  selectedIds,
  isAllFilteredSelected,
}: {
  signals: readonly T[];
  excludedIds: ReadonlySet<string>;
  selectedIds: ReadonlySet<string>;
  isAllFilteredSelected: boolean;
}): T[] =>
  excludeArchivedSignals(
    signals.filter((signal) =>
      isAllFilteredSelected
        ? !excludedIds.has(signal.id)
        : selectedIds.has(signal.id),
    ),
  );
